import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-tubewell-connection-dashboard',
  templateUrl: './tubewell-connection-dashboard.component.html',
  styleUrls: ['./tubewell-connection-dashboard.component.scss'],
})
export class TubewellConnectionDashboardComponent implements OnInit {
  @ViewChild('targetTable') targetTable: ElementRef;

  public showOwnMIResourceCard: boolean = false;
  public ownMIfarmerDetailsForm: FormGroup;

  public componentMasterList: any = [];
  public miVendorList: any = [];
  public filteredmiVendorList: any = [];

  public uploadedBillFiles: any[] = [];

  public blockSpace: RegExp = /^[^\s,]([^,]*[^\s,])?$/;

  public ipAddress: any = '000.000.000';

  public filteredVillage: any[];
  public villageList: any;

  public finYearList: any[] = [];

  public subjectSub: any;
  public subscriptions: any = [];

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private loader: AppLoaderService,
    private fApplicationService: FarmersApplicationService,
    private messageService: MessageService,
    private _personalDetalSer: FarmersDetailsService,
    private ipService: IpAddressService,
    private reportService: ReportsService,
    private cryptoJsService: CryptoJsService,
  ) { }

  ngOnInit(): void {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);

    farmerconfData.delete('isApplyForNocRed');

    const dataF = JSON.stringify(Array.from(farmerconfData.entries()));
    sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));


    this.ownMIfarmerDetailsForm = this.fb.group({
      appNo: ['', [Validators.required]],
      name: ['', [Validators.required]],
      fatherName: ['', [Validators.required]],
      programmeName: [0, [Validators.required]],
      vendor: ['', [Validators.required]],
      killaNo: ['', [Validators.required]],
      totalArea: [0, [Validators.required]],
      villageCode: ['', [Validators.required]],
      finYear: ['', [Validators.required]],
      mobileNo: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      aadharNo: [
        '',
        [
          Validators.required,
          Validators.minLength(12),
          Validators.maxLength(12),
        ],
      ],
      billPath: ['', Validators.required],
      landOwnerPath: ['', Validators.required],
      // nocCertificatePath: ['',],

      // enteredQuantity: ['', [Validators.required, Validators.min(0)]],
      // coveredArea: ['', [Validators.required, Validators.min(0)]],
    });

    this.getVillageData();
    // this.getFinYearList();
    this.getIP();

    setTimeout(() => {
      this.componentMasterList = [
        {
          Program_Id: 1,
          Program_Name: 'Portable Sprinkler',
          Active: true,
        },
        {
          Program_Id: 2,
          Program_Name: 'Mini Sprinkler',
          Active: true,
        },
        {
          Program_Id: 3,
          Program_Name: 'Drip',
          Active: true,
        },
      ];
    }, 100);


    let farmerMobNo = farmerconfData.get('ownMIfarmerPh') ? farmerconfData.get('ownMIfarmerPh') : '';

    this.ownMIfarmerDetailsForm.controls.mobileNo.setValue(farmerMobNo);

    setTimeout(() => {
      this.finYearList = [
        { FinancialYears: "2010-11" },
        { FinancialYears: "2011-12" },
        { FinancialYears: "2012-13" },
        { FinancialYears: "2013-14" },
        { FinancialYears: "2014-15" },
        { FinancialYears: "2015-16" },
        { FinancialYears: "2016-17" },
        { FinancialYears: "2017-18" },
        { FinancialYears: "2018-19" },
        { FinancialYears: "2019-20" },
        { FinancialYears: "2020-21" },
        { FinancialYears: "2021-22" },
        { FinancialYears: "2022-23" },
        { FinancialYears: "2023-24" },
      ]
    }, 100)
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  getFinYearList() {
    let sub = this.reportService
      .getFinanacialYearList()
      .pipe(first())
      .subscribe({
        next: (data) => {
          if (data?.length > 0) {
            this.finYearList = data;
          } else {
            this.finYearList = [];
          }
        },
        error: (err) => {
          this.finYearList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Finanacial Year',
            detail: err,
          });
        },
      });

    this.subscriptions.push(sub);
  }

  onClickAvailSub() {
    this.showOwnMIResourceCard = false;
    // const url = this.router.createUrlTree(['phone-login']).toString();
    // window.open(url, '_blank');

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);

    farmerconfData.set('isApplyForNocRed', '1');

    const dataF = JSON.stringify(Array.from(farmerconfData.entries()));
    sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));


    this.router.navigate(['farmer/dashboard']);
    // this.messageService.add({
    //   severity: 'info',
    //   summary: 'Info Message',
    //   detail: 'Wait, functionilty available soon.',
    // });
  }

  onClickExtMI() {
    this.showOwnMIResourceCard = true;

    setTimeout(
      () =>
        this.targetTable.nativeElement.scrollIntoView({
          block: 'center',
          behavior: 'smooth',
        }),
      200
    );
  }

  getVillageData() {
    this._personalDetalSer.getVillageMatserData().subscribe((res) => {
      // this.loader.close();
      this.villageList = res;
      this.filteredVillage = [...this.villageList];

      // if (this.farmerData?.Village_Code) {
      //   let village = this.villageList?.filter(val => val?.Code === this.farmerData?.Village_Code)[0]
      //   this.farmersFormControls.village.setValue(village?.Name);
      //   this.selectedVillage = village;
      // }

      if (!window.localStorage.getItem('villageMaster')) {
        window.localStorage.setItem('villageMaster', JSON.stringify(res));
      }
    });
  }

  filterVillage(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }

    this.filteredVillage = filtered;
  }

  onSelectProgramme() {
    this.ownMIfarmerDetailsForm.controls['vendor'].reset();
    // this.vendor = [];

    // this. showErrMsgOfInvArea = false;
    // this.invAreaMsg = null;

    // let vendor = this.estimationDetailsForm.controls['vendor'].value;
    let vendor = 0;
    let programme = this.ownMIfarmerDetailsForm.controls['programmeName'].value;
    this.getVendorDropdown(programme?.Program_Id);
  }

  getVendorDropdown(programId) {
    this.loader.start();
    this.fApplicationService
      .getAllMIvenders(programId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.miVendorList = res;
        },
        error: (err) => {
          this.loader.close();
          this.miVendorList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  filterMIVendor(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.miVendorList.length; i++) {
      const vendor = this.miVendorList[i];
      if (vendor.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(vendor);
      }
    }
    this.filteredmiVendorList = filtered;
  }

  onBillUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let farmerMobNo = farmerconfData.get('ownMIfarmerPh') ? farmerconfData.get('ownMIfarmerPh') : '';

    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, farmerMobNo, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200 && resp.message == 'Sucessfull') {
          this.uploadedBillFiles = [];
          for (let file of event.files) {
            this.uploadedBillFiles.push(file);
          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Bill Uploaded Successfully',
          });
          this.ownMIfarmerDetailsForm.patchValue({ [formcontrol]: resp.data });
        }
      });
    uploadElement.clear();
  }

  onLandOwnPaperUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);

    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let farmerMobNo = farmerconfData.get('ownMIfarmerPh') ? farmerconfData.get('ownMIfarmerPh') : '';

    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, farmerMobNo, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200 && resp.message == 'Sucessfull') {
          this.uploadedBillFiles = [];
          for (let file of event.files) {
            this.uploadedBillFiles.push(file);
          }

          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Bill Uploaded Successfully',
          });
          this.ownMIfarmerDetailsForm.patchValue({ [formcontrol]: resp.data });
        }
      });
    uploadElement.clear();
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = ipAddress;
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        farmerConfData.set('ipAddress', this.ipAddress)

        const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }

  onSubmitfarmerOwnMIDetails() {
    if (!this.ownMIfarmerDetailsForm.invalid) {
      let val = this.ownMIfarmerDetailsForm.value;
      let reqBody = {
        appId: val?.appNo,
        progId: val?.programmeName?.Program_Id,
        areaAcre: val?.totalArea,
        killaNo: val?.killaNo,
        vendor: val?.vendor?.Vendor_Code,
        uploadedBillPath: val?.billPath,
        landOwnershipDoc: val?.landOwnerPath,
        farmerMobile: val?.mobileNo,
        aadhaarNo: val?.aadharNo,
        farmer_Name: val?.name,
        father_Name: val?.fatherName,
        fin_Year: val?.finYear?.FinancialYears,
        village: val?.villageCode?.Code,
        nocCertificcate: val?.nocCertificatePath,
        networkId: this.ipAddress,
        terminalId: this.ipAddress,
      };

      let encryptedData = this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody));
      // this.submitDetails(reqBody);
      this.checkAppVal(reqBody);
    } else {
      this.ownMIfarmerDetailsForm.markAllAsTouched();
    }
  }

  checkAppVal(reqBody) {
    this.loader.start();
    this.fApplicationService
      .getUHBVNData(reqBody?.appId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if (res[0]?.Message == 'Application Found') {
            // this.messageService.add({
            //   severity: 'success',
            //   summary: 'Success Message',
            //   detail: res,
            // });

            this.submitDetails(reqBody);

          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res[0]?.Message,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  submitDetails(reqBody) {
    this.loader.start();
    this.fApplicationService
      .submitOwnMIFarmerDetail(reqBody)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if (res == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: res,
            });

            this.ownMIfarmerDetailsForm.reset();

            const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
            const farmerconfData = new Map(encData);
            let farmerMobNo = farmerconfData.get('ownMIfarmerPh') ? farmerconfData.get('ownMIfarmerPh') : '';

            this.ownMIfarmerDetailsForm.controls.mobileNo.setValue(farmerMobNo);

          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: res,
            });
          }
        },
        error: (err) => {
          this.loader.close();

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  downloadNOC() {
    this.messageService.add({
      severity: 'info',
      summary: 'Info Message',
      detail: 'Not available. Try again later.',
    });
  }
}
